import { getUserParamsForIntercom as getUserParams } from 'Utils'

export const handlers = () => ({
  bootIntercom: () => (user) => {
    const params = getUserParams(user)
    global.Intercom('boot', {
      ...(params.user_id ? params : {}),
      alignment: 'right',
      source: process.env.REACT_APP_SOURCE_NAME,
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      environment: process.env.REACT_APP_ENVIRONMENT,
    })
  },
  updateIntercom: () => (params) => {
    global.Intercom('update', params)
  },
  shutdownIntercom: () => () => {
    global.Intercom('shutdown')
  },
})

export const onComponentDidMount = (props) => {
  const user = getUserParams()
  props.bootIntercom(user)
}

export const onComponentDidUpdate = (prevProps, props) => {
  const {
    location: { search, pathname },
  } = props

  const {
    location: { pathname: previousPathname, search: previousSearch },
  } = prevProps

  if (`${pathname}${search}` !== `${previousPathname}${previousSearch}`) {
    props.updateIntercom({ alignment: 'right' })
  }
}
